<template>
    <div class="detail">
        <div class="detail-i" style="margin-top: 56px;">
            <div class="detail-title">基础信息</div>
            <div class="detail-con">
                <forms ref="formListDetail" :list="formList1" :value="formData" labelWidth="120px"></forms>
            </div>
        </div>
        <div class="detail-i">
            <div class="detail-title">认证信息</div>
            <div class="detail-con">
                <forms ref="formListDetail" :list="formList2" :value="formData" labelWidth="120px"></forms>
                <!-- <div class="flexccs rz" v-if="formData.realName" @click="renzheng()">
                    实名认证
                </div>
                <div class="flexccs rz" v-if="formData.isEducation" @click="renzheng()">
                    学历认证
                </div>
                <div class="flexccs rz" v-if="formData.isRealEstate" @click="renzheng()">
                    房产认证
                </div>
                <div class="flexccs rz" v-if="formData.isVehicle" @click="renzheng()">
                    车辆认证
                </div>
                <div class="flexccs rz" v-if="formData.isIncome" @click="renzheng()">
                    收入认证
                </div>
                <div class="flexccs rz" v-if="formData.isCareer" @click="renzheng()">
                    职业认证
                </div> -->
            </div>
        </div>
        <div class="detail-i">
            <div class="detail-title">基础资料</div>
            <div class="detail-con">
                <forms ref="formListDetail" :list="formList3" :value="formData" labelWidth="120px"></forms>
            </div>
        </div>
        <div class="detail-i">
            <div class="detail-title">详细资料</div>
            <div class="detail-con">
                <forms ref="formListDetail" :list="formList4" :value="formData" labelWidth="120px"></forms>
                <forms ref="formListDetail" :list="formList5" :value="formData" labelWidth="120px"></forms>
            </div>
        </div>
        <div class="detail-i">
            <div class="detail-title">希望另一半</div>
            <div class="detail-con">
                <forms ref="formListDetail" :list="formList6" :value="formData" labelWidth="120px"></forms>
            </div>
        </div>
        <div class="detail-i">
            <div class="detail-title">图片展示</div>
            <div class="detail-con">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="item"
                    :preview-src-list="picList"
                    v-for="(item,index) in picList"
                    :key="index"
                    fit="cover"></el-image>
            </div>
        </div>
        <div class="detail-i">
            <div class="detail-title">视频展示</div>
            <div class="detail-con">
                <video :src="videoPath" class="table-video"></video>
            </div>
        </div>
        <div class="btns">
            <el-button type="primary" @click="submitData">确认提交</el-button>
        </div>
        <div class="detail-i">
            <div class="detail-title">语音展示</div>
            <div class="detail-con">
                <audio controls="controls" ref="audio">
                    <source :src="audioPath" type="audio/mpeg">
                </audio>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { ZhiYe,ShenGao,TiZhong,Age,Education,Income,Marital,MaritalType,Constellation,FamilyBackground,Maritalyq,Houseyq,Jsdfxh,Carqk,Houseqk } from '../../../assets/data/data.json';
const memberTypeList = [
    { label: '普通用户', value: 0 },
    { label: '普通会员', value: 1 },
    { label: '尊享会员', value: 2 },
    { label: '体验会员', value: 3 }
]
export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            ZhiYe:ZhiYe,
            ShenGao:ShenGao,
            TiZhong:TiZhong,
            Age:Age,
            Education:Education,
            Income:Income,
            Marital:Marital,
            MaritalType:MaritalType,
            Constellation:Constellation,
            FamilyBackground:FamilyBackground,
            Maritalyq:Maritalyq,
            Houseyq:Houseyq,
            Jsdfxh:Jsdfxh,
            Carqk:Carqk,
            Houseqk:Houseqk,
            formData:{},
            formList1:[
                {type: "text",label: "用户ID:",name: "userId"},
                {type: "header",label: "用户头像:",name: "header",func:this.uploadHeader},
                {type: "input",label: "用户昵称:",name: "nickName"},
                // {type: "input",label: "用户名称:",name: "name"},
                {type: "select",label: "会员类型:",name: "memberType",options:memberTypeList},
            ],
            formList2:[
                {type: "input",label: "手机:",name: "phone"},
                {type: "input",label: "微信:",name: "weChat"},
                {type: "input",label: "QQ:",name: "qq"},
            ],
            formList3:[
                {type: "select2",label: "年龄:",name: "age",options: Age},
                {type: "select2",label: "星座:",name: "constellation",options: Constellation},
                {type: "select2",label: "身高:",name: "height",options: ShenGao},
                {type: "select2",label: "体重:",name: "weight",options: TiZhong},
                {type: "select",label: "学历:",name: "education",options: Education},
                {type: "select2",label: "职业:",name: "zhiYe",options: ZhiYe},
                {type: "input",label: "现居住:",name: "currentAddress"},
                {type: "input",label: "户籍地:",name: "placeAddress"},
            ],
            formList4:[
                // {type: "select",label: "月收入:",name: "incomeStr",options: Income},
                // {type: "select",label: "家庭背景:",name: "familyBackground",options: FamilyBackground},
                // {type: "select",label: "是否独生子女:",name: "onlyChild",options: [{label: '是', value: true},{label: '否', value: false}]},
                // {type: "select",label: "买房情况:",name: "houseqk",options:Houseqk},
                // {type: "select",label: "买车情况:",name: "carqk",options:Carqk},
                // {type: "select",label: "婚姻状况:",name: "marital",options: MaritalType},
                // {type: "select",label: "何时结婚:",name: "marriedDate",options:Marital},
            ],
            formList5:[
                {type: "select",label: "月收入:",name: "income",options: Income},
                {type: "select2",label: "家庭背景:",name: "familyBackground",options: FamilyBackground},
                {type: "select",label: "是否独生子女:",name: "onlyChild",options: [{label: '是', value: true},{label: '否', value: false}]},
                {type: "select2",label: "买房情况:",name: "houseqk",options:Houseqk},
                {type: "select2",label: "买车情况:",name: "carqk",options:Carqk},
                {type: "select",label: "婚姻状况:",name: "marital",options: MaritalType},
                {type: "select2",label: "何时结婚:",name: "marriedDate",options:Marital},
                {type: "selectList",label: "爱好:",name: "aiHao",optionsValue:'lable',optionsLable:'lable',options:this.aihaos},
                {type: "selectList",label: "恋爱:",name: "lianAi",optionsValue:'lable',optionsLable:'lable',options:this.lianaizz},
                {type: "selectList",label: "性格:",name: "xingGe",optionsValue:'lable',optionsLable:'lable',options:this.xingges},
            ],
            formList6:[
                {type: "select2",label: "最小年龄要求:",name: "minAge",options: Age},
                {type: "select2",label: "最大年龄要求:",name: "maxAge",options: Age},
                {type: "select2",label: "最低身高要求:",name: "minHeight",options: ShenGao},
                {type: "select",label: "最低学历要求:",name: "minEducation",options: Education},
                {type: "select",label: "最低月薪要求:",name: "minIncome",options: Income},
                {type: "select2",label: "住房要求:",name: "houseyq",options:Houseyq},
                {type: "select",label: "婚姻状况要求:",name: "maritalyq",options: Maritalyq},
                {type: "select",label: "接受小孩:",name: "jsdfxh",options:Jsdfxh},
                {type: "selectList",label: "希望TA:",name: "hopeSideList"},
            ],
            aihaos:[],
            lianaizz:[],
            marriedDate:[],
            tedians:[],
            xingges:[],

            picList:[],
            videoPath:'',
            audioPath:''
        }
    },
    created(){
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        async uploadHeader(file){
            let res= await api.uploadImage(file.file);
            this.formData.header = res;
        },
        async getTags(gender){
            let res  = await api.GetTags(gender);
            this.aihaos = res.data.data.aihaos;
            this.lianaizz = res.data.data.lianaizz;
            this.marriedDate = res.data.data.marriedDate;
            this.tedians = res.data.data.tedians;
            this.xingges = res.data.data.xingges;
            for(let i in this.formList5){
                if(this.formList5[i].name == 'aiHao'){
                    this.formList5[i].options = this.aihaos
                }else if(this.formList5[i].name == 'lianAi'){
                        this.formList5[i].options = this.lianaizz
                }else if(this.formList5[i].name == 'xingGe'){
                    this.formList5[i].options = this.xingges
                }
            }
        },
        async getDetail(){
            let res  = await api.UserPager({
                userId: this.$route.query.id,
                page: 1,
                pageSize: 10,
            });
            this.formData = res.data.data.data[0];
            this.formData.myTag = JSON.parse(this.formData.myTags);
            this.formData.hopeSideList = JSON.parse(this.formData.hopeSides);

            this.formData.aiHao = JSON.parse(this.formData.myTags).AiHao
            this.formData.lianAi = JSON.parse(this.formData.myTags).LianAi
            this.formData.xingGe = JSON.parse(this.formData.myTags).XingGe
            if(this.formData.memberType > 0){
                this.formList1.push({type: "text",label: "会员过期时间:",name: "vipEndDate"})
            }
            this.getTags(this.formData.gender)
        },
        async submitData(){
           
            // this.formData.age = this.formData.age + ''
            // this.formData.height = this.formData.height + ''
            // this.formData.weight = this.formData.weight + ''
            // this.formData.minAge = this.formData.minAge + ''
            // this.formData.maxAge = this.formData.maxAge + ''
            // this.formData.minHeight = this.formData.minHeight + ''
            // console.log(this.formData.age);
            // console.log(this.formData.height);
            // console.log(this.formData.weight);
            // console.log(this.formData.minAge);
            // console.log(this.formData.maxAge);
            // console.log(this.formData.minHeight);
            // this.formData.age = parseInt(this.formData.age.split("岁")[0]);
            console.log(this.formData.age)
            console.log(this.formData.height)
            console.log(this.formData.weight)
            this.formData.age = this.formData.age + ''
            this.formData.height = this.formData.height + ''
            this.formData.weight = this.formData.weight + ''
            this.formData.minAge = this.formData.minAge + ''
            this.formData.maxAge = this.formData.maxAge + ''
            this.formData.minHeight = this.formData.minHeight + ''
            if(this.formData.age.indexOf('岁')!=-1){
                this.formData.age = parseInt(this.formData.age.split("岁")[0]);
            }
            if(this.formData.height.indexOf('CM')!=-1){
                this.formData.height = parseInt(this.formData.height.split("CM")[0]);
            }
            if(this.formData.weight.indexOf('KG')!=-1){
                this.formData.weight = parseInt(this.formData.weight.split("KG")[0]);
            }

            if(this.formData.minAge.indexOf('岁')!=-1){
                this.formData.minAge = parseInt(this.formData.minAge.split("岁")[0]);
            }
            if(this.formData.maxAge.indexOf('岁')!=-1){
                this.formData.maxAge = parseInt(this.formData.maxAge.split("岁")[0]);
            }
            if(this.formData.minHeight.indexOf('CM')!=-1){
                this.formData.minHeight = parseInt(this.formData.minHeight.split("CM")[0]);
            }
            // this.formData.minAge = parseInt(this.formData.minAge.split("岁")[0]);
            // this.formData.maxAge = parseInt(this.formData.minAge.split("岁")[0]);
            // this.formData.minHeight = parseInt(this.formData.minHeight.split("CM")[0]);
            // console.log(this.formData);

            this.formData.aiHao = JSON.parse(this.formData.myTags).AiHao
            this.formData.lianAi = JSON.parse(this.formData.myTags).LianAi
            this.formData.xingGe = JSON.parse(this.formData.myTags).XingGe
            this.formData.myTag = {AiHao:this.formData.aiHao, LianAi:this.formData.lianAi, XingGe:this.formData.xingGe};

            let res  = await api.EditUser(this.formData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
            }
        },

    }
    
}
</script>

<style lang="scss" scoped>
.detail{
    padding-top: 10px;
}
.item{
    display: flex;
    align-items: center;
}
.detail-title{
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    padding-left: 15px;
}
.content{
    display: flex;
    flex-wrap: wrap;
}
.detail-i{
    background-color: #ffffff;
    margin-top: 10px;
}
.btns{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
}
</style>
